<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="4">
        <el-input v-model="form.code" size="small" placeholder="投放编号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.bloggerName" size="small" placeholder="博主名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">博主总数：{{ page.total }}条</div>
        <div>
          <el-badge v-if="type === 'ExamineProcessing'" style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="openDialog">批量审批</el-button>
          </el-badge>
        </div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small" @selection-change="handleSelectionChange">
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column label="投放编号" min-width="120" prop="code" align="center"></el-table-column>
        <el-table-column label="博主名称" prop="bloggerName" min-width="160" align="center">
          <template slot-scope="scope">
            <div class="account-wrap">
              <div class="avatar-out">
                <div class="avatar-in">
                  <div class="img-wrap" v-if="scope.row.avatar">
                    <!--有头像-->
                    <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                    <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                  </div>
                  <div class="img-wrap" v-else>
                    <img src="/img/media/weibo_default.png" class="avatar">
                  </div>
                </div>
              </div>
              <div class="info-wrap">
                <el-tooltip :content="scope.row.bloggerName" placement="bottom" effect="light">
                  <div class="nickname"><span>{{ scope.row.bloggerName }}</span></div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平台" prop="mediaType" align="center">
          <template slot-scope="scope">
            {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, '') }}
          </template>
        </el-table-column>
        <el-table-column label="关联合同" prop="contract" align="center" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.contractName">
              <p>{{ scope.row.contractName }}</p>
              <p class="non-wrap">（<span :class="['color_' + contractConfig.getAppointed('status_color', scope.row.contractStatus)]">{{ contractConfig.getAppointed("status_summary", scope.row.contractStatus, '') }}</span>）</p>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="申请提交人" prop="applyUserName" align="center">
        </el-table-column>
        <el-table-column label="审批状态" prop="auditStatus" align="center">
          <template slot-scope="scope">
            <p>
              {{ approveConfig.getAppointed("statusCustomer", scope.row.auditStatusAdd, "") }}
            </p>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="type === 'ExamineProcessing'" type="text" size="small" @click="toAssess(scope.row.id)">审批</el-button>
            <el-button v-if="object===1&&(scope.row.status===2||scope.row.status===3)" type="text" size="small" @click="toAssess(scope.row.id)">重审</el-button>
            <el-button v-else-if="type === 'Processing'&&object===2" type="text" size="small" @click="toAssess(scope.row.id)">重审</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <el-dialog
      title="分类详情"
      :visible.sync="fenleiVisible"
      width="30%">
      <div class="fenleiFlex">
        <div style="margin:5px;" v-for="(item,index) in classificationList" :key="index">
          <el-tag>{{classificationType==1?item:item.categoryName}}</el-tag>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible">
      <el-form v-if="dialogTitle==='批量审批'" label-position="left" :model="assessForm" ref="assessForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="审批状态" prop="status" class="block-form-item w-99">
          <el-select v-model="assessForm.status" @change="statusChange">
            <el-option label="审批通过" value=1></el-option>
            <el-option label="审批不通过" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="assessForm.status == 0" label="原因" prop="notPassReason" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="assessForm.notPassReason"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="batchClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import util from "@/util/util";
import { customConfig } from "@/const/config/custom";
import { approveConfig } from "@/const/config/approve";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
import { deliveryConfig } from "@/const/config/delivery";

import { deliveryList ,assessDeliveryAddBatch} from "@/api/approve/delivery";
export default {
  props: ["type"],

  data() {
    return {
      object: null,
      customConfig: customConfig,
      approveConfig: approveConfig,
      mediaConfig: mediaConfig,
      contractConfig: contractConfig,
      deliveryConfig: deliveryConfig,

      form: {
        code: "",
        bloggerName: "",
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      classificationList:[],
      classificationType:'',
      fenleiVisible:false,
      multiSelectList:[],
      dialogTableVisible:false,
      dialogTitle:"",
      //审批
      assessForm: {
        ids:[] ,
        status: "1",
        notPassReason: "",
        auditRemark: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        nameOrCode: "",
        createUserName: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      queryObj.auditFlag = customConfig.Status[this.type];
      queryObj.type = 0 ;
      console.log("queryObj", queryObj);
      this.tableLoading = true;
      deliveryList(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.object = res.object;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 展示原因
     * @param text 原因类型
     * @param reason 原因
     */
    onShowReason(text, reason) {
      reason = reason || "原因";
      text = text || "";
      this.$alert(text, reason, {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 跳转到审批页
     */
    toAssess(id) {
      let router = this.$router.push({
        path: "/check/delivery/add/assess",
        query: {
          id,
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },

    //打开调整输入框
    openDialog(obj){
      this.dialogTitle = '批量审批' ;
      this.dialogTableVisible = true ;
      console.log("======"+obj);
    },

    //批量审批
    batchClick(){
      console.log(this.multiSelectList) ;
      var ids = []
      this.multiSelectList.forEach(element => {
        ids.push(element.id)
      });
      this.assessForm.ids = ids ;
      console.log(ids) ;
      let obj = {};
      obj.ids = ids;
      obj.isPass = parseInt(this.assessForm.status);
      obj.notPassReason = this.assessForm.notPassReason; //审批失败原因
      obj.auditRemark = this.assessForm.auditRemark;
      assessDeliveryAddBatch(obj)
        .then((res) => {
            this.$message.success("审批成功");
            this.dialogTableVisible = false
            this.getList();
        })
        .catch((error) => {
          this.dialogTableVisible = false
        });
    },

    //审批状态改变
    statusChange(val) {
      this.assessForm.notPassReason = "";
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
    //分类数据
    classificationDetails(data,type){
      this.fenleiVisible = true;
      this.classificationList = data;
      this.classificationType = type;
      console.log('====数据======',data)
    },
  },
};
</script>

<style>
.el-table__expand-icon{
  z-index: 99999;
}
</style>
<style lang="scss" scoped>
.fenleiFlex{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

/* 博主名称样式修改 */
// /deep/.el-table_1_column_2{
//   .cell{
//     display: flex !important;
//     align-items: center !important;
//   }
// }

/deep/.el-table__indent{
  padding-left: 0 !important;
}
.overflow-content-wrap{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.media-price-wrap li{
  font-size: 14px;
}
.disbox_flx{
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
//分类项
  .category-item {
    display: inline-block;
    margin: 3px;
    font-size: 12px;
  }
  //更多价格
  .more-price {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    cursor: pointer;
    .iconfont {
      margin-right: 5px;
      font-weight: bold;
    }
  }
.typeImgWx{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
}
.typeImgTb{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -182px;
}
.typeImgDy{
  display: inline-block;
  width: 50px;
  height: 30px;
  margin-top: 5px;
  background: url('/img/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -92px;
}

// 购物车
.cart_box{
  position: fixed;
  right: 0;
  top: 260px;
  margin-bottom: 10px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  text-align: center;
  background: #1e1e1e;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  cursor: pointer;
  color: #FFF;
  z-index: 99;
}


.main-container {
  margin: 20px;
}

// 抽屉样式处理
.drawerIndex{
  z-index: 0 !important;
}
.el-table::before{
  z-index: 0 !important;
}

//处理博主名称  ---影响其他
// /deep/.el-table .cell{
//   display: flex;
//   align-items: center;
// }

//列表“博主名称”特殊处理
/deep/ .el-table th:nth-child(2) div{
  display: inline-block !important;
  text-align: center;
}
//列表“博主名称”特殊处理
/deep/.el-table__row td:nth-child(2) .cell{
  display: flex;
  align-items: center;
}

/deep/ .el-table th:nth-child(1) div{
  display: inline-block !important;
  text-align: center;
}
//列表“博主名称”特殊处理
/deep/.el-table__row td:nth-child(1) .cell{
  display: flex;
  align-items: center;
}


.account-wrap {
    display: flex;
    cursor: pointer;
    //头像
    .avatar-out {
      /*width: 50%;*/
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .avatar-in {
        position: relative;
        width: 42px;
        height: 42px;
        margin-right: 10px;
        float: right;
        .img-wrap {
          position: relative;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            &.is-code {
              position: absolute;
              top: -84px;
              left: -84px;
              width: 210px;
              height: 210px;
            }
          }
        }
      }
    }
    //基础信息
    .info-wrap {
      display: flex;
      align-items: center;
      width: 80%;
      font-size: 12px;
      text-align: left;
      .nickname {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }


  /deep/.el-drawer__header{
    font-size: 20px;
    font-weight: 500;
  }
  //隐藏滚动条
  .el-scrollbar__thumb {
    display: none;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: auto;
  }
  // 抽屉
  .drawer_hei{
    overflow: auto;
    height: 100%;
    padding-bottom: 240px;
  }
  .drawer_head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #999;
    padding:15px;
    padding-top: 0;
    font-size: 15px;
    position: relative;

  }
  .drawer_fixed_box{
    position: absolute;
    bottom:0;
    width: 100%;
    height: 60px;
    color: #FFF;
    line-height: 60px;
    font-size: 15px;
    text-align: center;
    z-index: 10;
    background: #d9001b;
  }
  .drawer_fixed_text{
    height: 40px;
    position: absolute;
    bottom: 60px;
    background: #fff;
    line-height: 40px;
    width: 100%;
    padding-left:15px;
    font-size: 14px;
  }
  .drawer_list{
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #EFEFEF;
    padding:0 15px;
  }
  .list_left,.cli_val{
    display: flex;
    align-items: center;
  }
  .cli_val{
    margin-left:10px;
  }
  .headerImg{
    width: 100%;
    height: 100%;
    border-radius: 100px;
  }
</style>
<style lang='scss' >
.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;
}

.indeterminate .el-checkbox__input.is-checked .el-checkbox__inner::after {
  transform: scale(0.5);
}

.indeterminate .el-checkbox__input .el-checkbox__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}
.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  border-color: #c0c4cc !important;
  background-color: #c0c4cc;
}
.product-show th .el-checkbox__inner {
  display: none !important;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  content: "";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 5px;
  width: auto !important;
}
.product-show .el-checkbox__inner {
  display: block !important;
}

.product-show .el-checkbox {
  display: block !important;
}
.sandian{
  margin-top:4px;
  margin-left: -3px;
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>